import React, { useEffect, useRef, useState } from "react";

const Ticker = ({ text = "Ticker Text", speed = 0.8, className = "" }) => {
  const containerRef = useRef(null);
  const textRef = useRef(null);
  const animationRef = useRef(null);
  const frameCountRef = useRef(0);
  const [isMobile, setIsMobile] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);

  // Detect if device is mobile
  useEffect(() => {
    const checkIfMobile = () => {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      const mobileRegex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
      setIsMobile(mobileRegex.test(userAgent));
    };

    checkIfMobile();
    setIsLoaded(true);
  }, []);

  useEffect(() => {
    if (!containerRef.current || !textRef.current || !isLoaded) return;

    const container = containerRef.current;
    const textElement = textRef.current;
    
    // Set initial position outside the visible area (to the right)
    let position = container.offsetWidth;
    textElement.style.transform = `translateX(${position}px)`;
    
    // Create clone for continuous flow
    const clone = textElement.cloneNode(true);
    clone.style.position = 'absolute';
    container.appendChild(clone);
    
    // Calculate gap between repeated texts - larger for desktop
    const gap = isMobile ? 50 : 120;
    
    // Position the clone right after the original
    clone.style.transform = `translateX(${position + textElement.offsetWidth + gap}px)`;

    // Animation speed - significantly faster on desktop
    const animationSpeed = isMobile ? speed : speed * 2.5;

    // Animation function with throttling
    const animate = () => {
      // Reduce throttling on desktop for smoother faster animation
      frameCountRef.current += 1;
      const frameSkip = isMobile ? 2 : 1;
      
      if (frameCountRef.current >= frameSkip) {
        position -= animationSpeed;
        frameCountRef.current = 0;
      }

      // If original text is too far to the left, reset position
      if (position < -textElement.offsetWidth - gap) {
        position += textElement.offsetWidth + gap;
      }

      textElement.style.transform = `translateX(${position}px)`;
      clone.style.transform = `translateX(${position + textElement.offsetWidth + gap}px)`;
      
      animationRef.current = requestAnimationFrame(animate);
    };

    animationRef.current = requestAnimationFrame(animate);

    return () => {
      if (animationRef.current) {
        cancelAnimationFrame(animationRef.current);
      }
      if (container.contains(clone)) {
        container.removeChild(clone);
      }
    };
  }, [text, speed, isMobile, isLoaded]);

  // Show once loaded
  const visibility = !isLoaded ? "invisible" : "visible";

  return (
    <div
      ref={containerRef}
      className={`w-full overflow-hidden flex justify-center items-center relative ${className}`}
      style={{ visibility }}
    >
      <div
        ref={textRef}
        className="absolute whitespace-nowrap font-medium flex gap-2"
        style={{ willChange: "transform" }}
      >
        <img src="https://assets.learntube.ai/files/certified%20app/Recommend.svg?updatedAt=1741343168361" alt="Recommend icon" />
        {text}
      </div>
    </div>
  );
};

const SingleItemTicker = ({ text }) => {
  return (
    <div className="w-full">
      <div
        className="h-[36px] flex items-center justify-center text-white"
        style={{
          background:
            "linear-gradient(135deg, #2E5CA4 0%, #244779 50%, #22426D 100%)",
        }}
      >
        <Ticker text={text} speed={0.8} className="h-full" />
      </div>
    </div>
  );
};

export default SingleItemTicker;